import type { EntryPoint, EntryPointComponent } from 'react-relay';
import parameters from '@atlassian/jira-relay/src/__generated__/PRDetailsPopupViewUiQuery$parameters';
import type { PRDetailsPopupViewUiQuery } from '@atlassian/jira-relay/src/__generated__/PRDetailsPopupViewUiQuery.graphql.ts';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { PRDetailsPopupViewNewProps } from './src/ui/types.tsx';

export const pullRequestDetailsNewEntryPoint: EntryPoint<
	EntryPointComponent<
		{
			pullRequestDetailsForIssue: PRDetailsPopupViewUiQuery;
		},
		{},
		PRDetailsPopupViewNewProps,
		{}
	>,
	{
		issueId: string;
		isNetworkOnly?: boolean;
	}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-pr-details-popup-new" */ './src/ui/PRDetailsPopupView.tsx'
			),
	),
	getPreloadProps: ({
		issueId,
		isNetworkOnly = false,
	}: {
		issueId: string;
		isNetworkOnly?: boolean;
	}) => ({
		queries: {
			pullRequestDetailsForIssue: {
				options: {
					fetchPolicy: isNetworkOnly ? ('network-only' as const) : ('store-and-network' as const),
				},
				parameters,
				variables: {
					issueId,
				},
			},
		},
	}),
});
